import { EmptyState } from '@/components/layout/empty-state';
import { Brain } from 'lucide-react';

// Admin / Models — registry of which model_id values are active vs shadow,
// plus calibration health (rolling Brier score, prediction distribution).
// V2 — needs endpoints model.list + model.calibration that we haven't
// built. For now: an honest empty state.

export function AdminModelsPage() {
  return (
    <EmptyState
      title="MODELOS"
      description="Versiones de modelos activos / shadow + calibración (Brier rolling, distribución de predicciones)."
      value="V2"
      unit="pendiente"
      hint="V1 acepta picks de cualquier modelo vía signals.create + el modelo 'manual' para tus picks. Esta vista de gestión llega cuando integremos múltiples modelos en paralelo (architecture § 9.2)."
      icon={Brain}
      badge="V2"
    />
  );
}
